module.exports = __webpack_public_path__ + "static/img/login-bkg.06615bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login-bkg.png
// module id = Q25O
// module chunks = 1